<template>
  <div class="componente-busca mb-2">
    <div class="xrow">
      <div v-if="showTipoFormulario" class="form-group col-1-4">
        <label>Tipo Formulário</label>
        <select
          class="form-control"
          v-model="tipoFormulario"
          :disabled="termoBuscaFormulario !== ''"
        >
          <option value="">Todos</option>
          <option v-for="tipo in tiposPermitidos" :key="tipo" :value="tipo">
            {{ tipo }}
          </option>
        </select>
      </div>

      <div class="col-1-4">
        <div class="form-group">
          <label>Data de Início</label>
          <datetime
            input-class="form-control"
            v-model="dataInicio"
            placeholder="Selecione a data de início"
            :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
            value-zone="local"
            type="datetime"
          />
        </div>
      </div>

      <div class="col-1-4">
        <div class="form-group">
          <label>Data de Fim</label>
          <datetime
            input-class="form-control"
            v-model="dataFim"
            placeholder="Selecione a data de fim"
            :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
            value-zone="local"
            type="datetime"
          />
        </div>
      </div>

      <div v-if="showFormularioBusca" class="form-group col-1-4">
        <label>Representante</label>
        <el-autocomplete
          class="search-select"
          v-model="termoBuscaRepresentante"
          :fetch-suggestions="buscarSugestoesRepresentante"
          placeholder="Buscar representante..."
          @select="selecionarRepresentante"
        />
      </div>

      <div class="form-group col-1-4">
        <label>Formulário</label>
        <el-autocomplete
          class="search-select"
          v-model="termoBuscaFormulario"
          :fetch-suggestions="buscarSugestoesFormulario"
          placeholder="Buscar formulário..."
          @select="selecionarFormulario"
        />
      </div>
    </div>

    <div class="xrow centraliza-busca">
      <div v-if="showFormularioBusca" class="col-1-1">
        <div class="form-group">
          <label>Cliente</label>
          <el-autocomplete
            class="search-select"
            v-model="termoBuscaCliente"
            :fetch-suggestions="buscarSugestoesCliente"
            placeholder="Buscar cliente..."
            @select="selecionarCliente"
          />
        </div>
      </div>
      <div class="search-action-buttons pull-right w-100">
        <button
          @click="aplicarFiltrosEBuscarDados"
          class="button button-primary col-1-4 button-styles"
          :disabled="carregando"
        >
          {{ carregando ? "Buscando..." : "Buscar" }}
        </button>
        <button
          @click="resetFiltros"
          class="button button-error col-1-4 button-styles"
        >
          Limpar
        </button>
        <el-dropdown @command="baixarArquivo">
          <el-button type="primary">
            Baixar <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="JSON">JSON</el-dropdown-item>
            <el-dropdown-item command="XML">XML</el-dropdown-item>
            <el-dropdown-item command="XLSX">XLSX</el-dropdown-item>
            <el-dropdown-item command="CSV">CSV</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { get, postBlob } from "@/helpers/apiRequest";

const DEBOUNCE_DELAY = 500;

export default {
  name: "SearchBarBase",
  props: {
    tiposPermitidos: {
      type: Array,
      default: () => [],
    },
    sistema: {
      type: String,
      required: true,
    },
    showTipoFormulario: {
      type: Boolean,
      default: false,
    },
    showFormularioBusca: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tipoFormulario: "",
      dataInicio: "",
      dataFim: "",
      termoBuscaRepresentante: "",
      termoBuscaCliente: "",
      termoBuscaFormulario: "",
      representanteSelecionadoId: null,
      clienteSelecionadoId: null,
      formularioSelecionadoId: null,
      carregando: false,
    };
  },
  computed: {
    filtrosLimpos() {
      const filtros = {
        tipo: this.termoBuscaFormulario ? null : this.tipoFormulario,
        sistema: this.sistema,
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
        representanteId: this.representanteSelecionadoId,
        clienteId: this.clienteSelecionadoId,
        formularioId: this.formularioSelecionadoId,
      };

      return Object.fromEntries(
        Object.entries(filtros).filter(
          ([_, value]) => value != null && value !== ""
        )
      );
    },
  },
  methods: {
    buscarSugestoesRepresentante: debounce(async function (query, callback) {
      try {
        const res = await get(
          `/admin/formularios/relatorio/representantes?q=${query}`
        );
        const sugestoes = res.map((rep) => ({ value: rep.nome, id: rep.id }));
        callback(sugestoes);
      } catch {
        callback([]);
      }
    }, DEBOUNCE_DELAY),

    buscarSugestoesCliente: debounce(async function (query, callback) {
      try {
        const res = await get(`/admin/clientes?q=${query}`);
        const sugestoes = res.itens.map((cli) => ({
          value: cli.razSoc || cli.fant,
          id: cli.id,
        }));
        callback(sugestoes);
      } catch {
        callback([]);
      }
    }, DEBOUNCE_DELAY),

    buscarSugestoesFormulario: debounce(async function (query, callback) {
      try {
        const params = new URLSearchParams();
        params.append("q", query);

        this.tiposPermitidos.forEach((tipo) => {
          params.append("tipo[]", tipo);
        });

        const res = await get(`/admin/formularios?${params.toString()}`);

        const sugestoes = res.map((form) => ({
          value: form.titulo,
          id: form.id,
        }));

        callback(sugestoes);
      } catch {
        callback([]);
      }
    }, DEBOUNCE_DELAY),

    selecionarRepresentante(item) {
      this.representanteSelecionadoId = item.id;
    },
    selecionarCliente(item) {
      this.clienteSelecionadoId = item.id;
    },
    selecionarFormulario(item) {
      this.formularioSelecionadoId = item.id;
    },

    aplicarFiltrosEBuscarDados() {
      if (this.dataInicio && this.dataFim && this.dataInicio > this.dataFim) {
        this.$message.error(
          "A data inicial não pode ser maior que a data final."
        );
        return;
      }
      this.obterDadosFiltrados(this.filtrosLimpos);
    },

    async obterDadosFiltrados(filtros) {
      this.carregando = true;
      try {
        const queryString = new URLSearchParams(filtros).toString();
        const res = await get(
          `/admin/formularios/pergunta/respostas?${queryString}`
        );
        this.$emit("filtros-aplicados", filtros);
        this.$emit("atualizar-lista", res);
      } catch (e) {
        console.error("Erro ao buscar dados:", e);
      } finally {
        this.carregando = false;
      }
    },

    async baixarArquivo(tipo) {
      try {
        const queryString = new URLSearchParams(this.filtrosLimpos).toString();
        const response = await postBlob(
          `/admin/formularios/pergunta/respostas/download?${queryString}&tipoArquivo=${tipo}`
        );
        const blob = await response.blob();

        const contentDisposition = response.headers.get("Content-Disposition");
        const filename =
          contentDisposition?.split("filename=")[1]?.replace(/"/g, "") ||
          `arquivo.${tipo.toLowerCase()}`;

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error(error);
        this.$message?.error(error);
      }
    },

    resetFiltros() {
      this.tipoFormulario = "";
      this.dataInicio = "";
      this.dataFim = "";
      this.termoBuscaRepresentante = "";
      this.termoBuscaCliente = "";
      this.termoBuscaFormulario = "";
      this.representanteSelecionadoId = null;
      this.clienteSelecionadoId = null;
      this.formularioSelecionadoId = null;
    },
  },
};
</script>

<style scoped>
.centraliza-busca {
  display: flex;
  align-items: center;
}
.search-action-buttons {
  display: flex;
  align-items: center;
  justify-content: end;
  padding-top: 12px;
  padding-right: 10px;
  flex-wrap: wrap;
  gap: 16px;
  width: 50%;
}
.search-action-buttons button {
  max-width: 11.5rem;
}
.search-select {
  width: 100%;
}
.button-styles {
  height: 40px;
  border-radius: 4px;
  max-width: 7.5rem !important;
}
</style>
